import { appConstants } from "../helpers/constants";

const initialState = {
  budgets: null,
  monthlyExpenseList: null,
  totalIncome: null,
  archive_budgets: [],
};

const budgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.GET_BUDGET_SUCCESS: 
      return {
        ...state,
        error: '',
        budgets: action.budgetList,
      };
    case appConstants.GET_BUDGET_FAILED: 
      return {
        ...state,
        error: action.error,
        isLoading: false,
        budgets: [],
      };
      
    case appConstants.GET_ARCHIVE_BUDGET_SUCCESS: 
      return {
        ...state,
        archive_budgets: action.budgetList,
        error: '',
      };
    case appConstants.REQUESTING_MONTLY_BUDGET:
      return {
        ...state,
        error: '',
        isLoading: true,
      };
    case appConstants.GET_MONTHLY_EXPENSE:
      return {
        ...state,
        monthlyExpenseList: action.monthlyExpenseList,
        totalBudget: action.totalBudget,
        totalSpent: action.totalSpent,
        totalIncome: action.totalIncome,
        error: '',
        isLoading: false,
      };
    case appConstants.GET_MONTHLY_INCOME:
      return {
        ...state,
        monthlyIncomeList: action.monthlyIncomeList,
        totalIncome: action.totalIncome,
        error: '',
        isLoading: false,
      };
    case appConstants.GET_MONTHLY_BUDGET_FAILED:
      return {
        ...state,
        error: action.error || '',
        isLoading: false,
      };
    case appConstants.INVALID_REQUEST:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
  
    // case DELETE_ITEM:
    //   return {
    //     ...state,
    //     numOfItems: state.numOfItems - 1,
    //   };
    default:
      return state;
  }
};

export default budgetReducer;
